import reducer from "./reducers";

import * as rolesAction from "./actions";

export { rolesAction };

export default reducer;
